"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticRingIACreator = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const StaticIA_1 = require("./StaticIA");
class StaticRingIACreator {
    static create(kette) {
        var _a, _b;
        const signature = `${this.className}.create`;
        if (!((_a = kette.localizedArtNr) === null || _a === void 0 ? void 0 : _a['DE'])) {
            throw new Error(`${signature}: Kette has no artNr`);
        }
        const ketteArtNrDe = kette.localizedArtNr['DE'];
        const staticIaBaseJsons = (_b = echain_shared_articles_1.ringIAsData.find((iaData) => iaData.ketteArtNr.includes(ketteArtNrDe))) === null || _b === void 0 ? void 0 : _b.staticIaJsons;
        if (!staticIaBaseJsons) {
            throw new Error(`${signature}: Could not find a staticIaBaseJson for ArtNr ${ketteArtNrDe}`);
        }
        return staticIaBaseJsons.map((staticIaBaseJson) => {
            return StaticIA_1.StaticIA.fromJson(staticIaBaseJson);
        });
    }
}
exports.StaticRingIACreator = StaticRingIACreator;
StaticRingIACreator.className = 'StaticRingIACreator';
//# sourceMappingURL=StaticRingIACreator.js.map